import { fromNode, TypedNode } from '@rehaje/core'
import { reactive, untrack } from '@rehaje/reactive'
import { isArray } from '@rehaje/shared'

import { ValuableModel } from '../../models'

import type { SchemaModel } from '../../models'
import type { SchemaArrayNode } from './TypedNode'

export class SchemaArrayModel extends ValuableModel<any[]> {
  __r_cache_items: any[] = []
  __r_cache_results: any[] = []

  @reactive()
  __r_cache_version = 0

  @fromNode()
  @reactive()
  maxItems?: number

  @fromNode()
  @reactive()
  minItems?: number

  constructor(node: SchemaArrayNode) {
    super(node)
    /**
     * FIXME：下面的用法会导致builder新表单在父子表单场景下出现值丢失的情况
     * 复现路径：拖入表格，下钻某项列配置，切换「文本」和「HTML」类型
     */
    // this.addForkedRefresher(
    //   this.form,
    //   ['__r_form_values', ...this.path.parts],
    //   node.items,
    //   start => this.refreshCache(start)
    // )
    this.addForkedRefresher(
      this,
      ['__r_form_values'],
      node.__r_getForkedChildren(),
      (start) => this.refreshCache(start)
    )
  }

  override joinChildNamePath(child: SchemaModel) {
    if (typeof child.index === 'number' && child.index > -1)
      return [...this.namePath, child.index, ...child.names]
    return [...this.namePath, ...child.names]
  }

  override joinChildrenValuePath(child: SchemaModel) {
    if (typeof child.index === 'number' && child.index > -1)
      return [...this.valuePath, child.index]
    return this.valuePath
  }

  refreshCache(start = 0) {
    if (start >= 0) {
      this.__r_cache_items.splice(start)
      this.__r_cache_results.splice(start)
      this.__r_cache_version++ // trigger reactive tracking
    }
  }

  renderItem(record: any, index: number, primaryKey?: PropertyKey) {
    const node = this.getTypedNode<SchemaArrayNode>()
    const items = node.items
    const item = isArray(items) ? (items[index] ?? node.additionalItems) : items
    const cacheItems = this.__r_cache_items
    const cacheResults = this.__r_cache_results

    void this.__r_cache_version // ensure reactive tracking

    if (
      index in cacheItems &&
      (primaryKey === undefined
        ? cacheItems[index] === record
        : cacheItems[index]?.[primaryKey] === record?.[primaryKey])
    ) {
      return cacheResults[index]
    }

    const result = untrack(() => {
      if (item instanceof TypedNode) {
        return node.batchEvaluate(() => {
          return item.fork(index).evaluate({
            $index: index,
            $realRecord: record,
            $record: record,
            $records: this.value
          })
        })
      }
    })

    cacheItems[index] = record
    cacheResults[index] = result
    return result
  }
}

declare global {
  export interface RehajeViewModels {
    'Schema.Array': SchemaArrayModel
  }
}
